import { Asset, TenantUserSettings } from '@/api/generatedApi';
import { createContext } from 'react';

export interface CompareCartState {
  selectedForCompare: { asset?: Asset };
  setSelectedForCompare: (selection: { asset?: Asset }) => void;
  isSelected: (assetId: string) => boolean;
  clearCart: () => void;
  getCompareUrl: (asset1: Asset, asset2: Asset, userSettings?: TenantUserSettings[]) => string;
}

export const CompareCartContext = createContext<CompareCartState | undefined>(undefined);
